/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { useContext } from 'preact/hooks';

import { MenuContainerContext } from './MenuContainerContext';

/**
 * Utility hook for consuming the MenuContainerContext
 *
 * @returns The value of MenuContainerContext provider
 */
function useMenuContainerContext() {
  return useContext(MenuContainerContext);
}

export { useMenuContainerContext };
